var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"dropdown",class:{active: _vm.isActive}},_vm.$listeners),[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value)+" "+_vm._s(_vm.countValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }